import React from 'react';
import { object, string } from 'yup';

import MESSAGES from '../../../locales';
import { Form, Input, Link, Button } from '../../_shared';

const Schema = object().shape({
  email: string()
    .max(200, MESSAGES['email.invalid'])
    .email(MESSAGES['email.invalid'])
    .required(MESSAGES['email.presence']),
});

const ForgotPasswordForm = (props) => {
  return (
    <Form schema={Schema} onSubmit={props.onSubmit}>
      <h3 className="mb-6 text-3xl text-center font-bold tracking-widest leading-7">
        {MESSAGES['resetPassword.title']}
      </h3>

      <Input
        id="email"
        name="email"
        label={MESSAGES['form.email']}
        type="email"
        autoComplete="off"
        required
      />
      {props.success && (
        <div className="text-green text-center text-sm mt-6">
          Sent reset password link successfully! Please check your email inbox.
        </div>
      )}
      {props.error && !props.success && (
        <div className="text-red text-center text-sm mt-6">{props.error}</div>
      )}
      <div className="flex flex-col mt-6">
        <Button
          className={`w-full font-semibold py-2 px-4 border border-solid rounded-lg text-white bg-primary`}
          type="primary"
          caption={MESSAGES['resetPassword.action.reset']}
          busy={props.busy}
        />
      </div>
      <div className="mt-4 flex flex-col items-center">
        <Link
          className="mt-3 no-underline font-bold cursor-pointer text-black text-base"
          to="/sign-in"
        >
          {MESSAGES['form.action.returnToSignIn']}
        </Link>
      </div>
    </Form>
  );
};

export default ForgotPasswordForm;
